import { HTTP_STATUS } from './httpstatu'
import logerror from './logerror'
import Axios, { AxiosResponse, Canceler } from 'axios'
import qs from 'query-string'
import { GetLocalStorage, DelLocalStorage, getUserId } from './util'
import { message } from 'antd'
import { CustomerWarning } from '../components/ModalUser'
import { history } from '../redux/store'
import InterceptRequestApi from '../api/InterceptRequestApi'
import { socketdisconnect } from './sockClient'
import { ResultState } from './public'
// 正在进行中的请求列表
const reqListData: any = []
// 请求到的数据
let resListData: { data: any; url?: string }[] = []
/**
 * 阻止重复请求
 * @param {array} reqList - 请求缓存列表
 * @param {string} url - 当前请求地址
 * @param {function} cancel - 请求中断函数
 */
const stopRepeatRequest = (
  reqList: string[],
  cancel: Canceler,
  url?: string,
) => {
  for (let i = 0; i < reqList.length; i++) {
    if (reqList[i] === url) {
      // 传递 url标识
      cancel(url)
      return
    }
  }
  reqList.push(url ? url : '')
}
/**
 * 允许某个请求可以继续进行
 * @param {array} reqList 全部请求列表
 * @param {string} url 请求地址
 */
const allowRequest = (reqList: any, url?: string) => {
  for (let i = 0; i < reqList.length; i++) {
    if (reqList[i] === url) {
      reqList.splice(i, 1)
      break
    }
  }
}

/**
 * 存储返回数据
 * @param data 响应数据
 * @param url 请求url
 */
const storageResponse = (data: any, url?: string) => {
  // 剔除旧数据
  const res = resListData.filter((item) => item.url !== url)
  // push 新数据
  res.push({
    data: data,
    url: url,
  })
  resListData = res
}

/**
 * 获取响应的数据
 * @param url
 */
const getUrlResponse = (url: string) => {
  // 旧数据
  const data = [...resListData]
  const res = data.filter((item) => item.url === url)
  if (res.length === 1) {
    return res[0].data
  }
  return { msg: '请勿重复操作' }
}

const axiosinster = Axios.create()
// 发送请求拦截
axiosinster.interceptors.request.use(
  (config) => {
    const url = config.url || ''
    const f = InterceptRequestApi.indexOf(url)
    if (f !== -1) {
      // 重复请求标识
      // eslint-disable-next-line @typescript-eslint/no-empty-function
      let cancel: Canceler = () => {}
      // 设置cancelToken对象
      config.cancelToken = new Axios.CancelToken(function (c: Canceler) {
        cancel = c
      })
      // 阻止重复请求。当上个请求未完成时，相同的请求不会进行
      stopRepeatRequest(reqListData, cancel, config.url)
    }
    // 获取本地token
    config.headers.Authorization = GetLocalStorage('SRM_TOKEN')

    // SUPPLIER_ORDER_ID 物流H5页面订单ID
    if (
      !GetLocalStorage('SRM_TOKEN') &&
      !sessionStorage.getItem('SUPPLIER_ORDER_ID')
    ) {
      history.replace('/login')
      return config
    }
    return config
  },
  (error) => {
    // 对请求错误做些什么
    return Promise.reject(error)
  },
)
//  响应拦截
axiosinster.interceptors.response.use(
  (response) => {
    // 增加延迟，相同请求不得在短时间内重复发送
    allowRequest(reqListData, response.config.url)
    // 对响应数据做点什么
    if (
      response.headers['content-type'] ===
      'application/octet-stream;charset=UTF-8'
    ) {
      return response
    }
    // 判断是否登录超时、未登录、权限不足等信息
    if (response.status === 200 && response.data.code === -1) {
      message.info('登录超时请重新登录！')
      // 销毁链接取消订阅
      socketdisconnect()
      DelLocalStorage('SRM_TOKEN')
      history.replace('/login')
    }
    if (response.status === HTTP_STATUS.NOT_FOUND) {
      logerror('api', '请求资源不存在')
    } else if (response.status === HTTP_STATUS.SERVER_ERROR) {
      logerror('api', '服务器异常')
    } else if (response.status === HTTP_STATUS.BAD_GATEWAY) {
      logerror('api', '服务端出现了问题')
    } else if (response.status === HTTP_STATUS.FORBIDDEN) {
      logerror('api', '没有权限访问')
    } else if (response.status === HTTP_STATUS.SUCCESS) {
      if (response.data.code === 3) {
        CustomerWarning({
          title: '提示',
          content: response.data.msg,
        })
        response.data.code = 0
      } else if (response.data.code === 1) {
        CustomerWarning({
          title: '提示',
          content: response.data.msg,
        })
      }
    }
    storageResponse(response.data, response.config.url)
    return response
  },
  (error) => {
    if (Axios.isCancel(error)) {
      const url = error.message
      // 拦截重复提交接口返回数据
      message.warning('请勿重复操作')
      return getUrlResponse(url)
    } else {
      // 增加延迟，相同请求不得在短时间内重复发送
      allowRequest(reqListData, error.config.url)
    }
    // 对响应错误做点什么
    logerror('api', '请求失败，网络连接异常')
    return Promise.reject(error)
  },
)

interface Params {
  data: { url: string; data?: any; contentType?: string }
  method: string
}
const options = async <T = any>(params: Params) => {
  const { url, data } = params.data
  const { method } = params
  const content_Type = 'application/json;charset=UTF-8'

  const OPTIONS = {
    ...{
      url: url,
      method: method,
      headers: {
        Accept: 'application/json;charset=UTF-8',
        'content-type': content_Type,
      },
    },
    ...data,
  }
  const res = await axiosinster.request<ResultState<T>>(OPTIONS)
  return res.data
}

const get = <T = any>(url: string, query?: any, data?: any) =>
  options<T>({
    data: {
      url: url,
      data: {
        data: data,
        params: { ...query, userId: getUserId() },
      },
    },
    method: 'GET',
  })
const post = <T = any>(
  url: string,
  data?: any,
  contentType?: string,
  query?: any,
  appendUserId = true,
) => {
  let newData
  if (contentType === 'multipart/form-data') {
    // formdata传参
    const formData = new FormData()
    const params = { userId: getUserId(), ...(data || {}) }
    const specialFileType = ['Blob', 'File']
    for (const key in params) {
      let value = params[key]
      if (
        params[key] instanceof Object &&
        !specialFileType.includes(params[key].constructor.name)
      ) {
        value = JSON.stringify(params[key])
      }
      formData.append(key, value)
    }
    newData = formData
  } else if (contentType === 'application/json') {
    let obj = {}
    try {
      obj = typeof data === 'string' ? JSON.parse(data) : data || {}
    } catch {
      obj = {}
    }
    newData = JSON.stringify(
      appendUserId ? { ...obj, userId: getUserId() } : obj,
    )
  } else {
    let obj = {}
    if (typeof data === 'string') {
      obj = qs.parse(data)
    } else {
      obj = data || {}
    }
    newData = qs.stringify({ ...obj, userId: getUserId() })
  }

  let dataToSend
  if (contentType === 'multipart/form-data') {
    dataToSend = newData
  } else if (typeof newData === 'object' && newData !== null) {
    dataToSend = newData // 已经处理过 userId
  } else {
    dataToSend = newData // 字符串类型
  }

  return options<T>({
    data: {
      url: url,
      data: { data: dataToSend, params: query },
      contentType: contentType,
    },
    method: 'POST',
  })
}
const del = (url: string, data?: any, contentType?: string, query?: any) => {
  let newData
  contentType === 'application/json'
    ? (newData = JSON.stringify(data))
    : (newData = qs.stringify(data))
  if (contentType === 'multipart/form-data') {
    // formdata传参
    const formData = new FormData()
    const params = data
    const specialFileType = ['Blob', 'File']
    for (const key in params) {
      let value = params[key]
      if (
        params[key] instanceof Object &&
        !specialFileType.includes(params[key].constructor.name)
      ) {
        value = JSON.stringify(params[key])
      }
      formData.append(key, value)
    }
    newData = formData
  }

  return options({
    data: {
      url: url,
      data: { data: newData, params: query },
      contentType: contentType,
    },
    method: 'DELETE',
  })
}

/**
 * 文件导出
 * @param url 请求路径
 * @param params 参数
 */
const fileGET = (url: string, params?: any) => {
  message.loading('文件导出中', 0)
  axiosinster
    .request({
      method: 'GET',
      url: url,
      params: params,
      headers: {
        Accept: 'application/json;charset=UTF-8',
        'content-type': 'application/x-www-form-urlencoded',
      },
      responseType: 'blob', // 服务器返回的数据类型
    })
    .then((response: AxiosResponse) => {
      const disposition = decodeURIComponent(
        response.headers['content-disposition'],
      )
      const fileName = disposition.split(';')[2].split('filename=')[1] // 下载文件名
      const name = fileName.substring(1, fileName.length - 1)
      // 返回的内容
      const content = response.data
      download(content, name)
      message.success('导出成功！')
      return response.data
    })
    .catch(() => {
      message.error('操作失败')
      return { data: {} }
    })
}
/**
 * 文件导入
 * @param url 请求路径
 * @param file 文件对象
 * @param params 参数
 */
const filePOST = async (url: string, file: any, params?: any) => {
  const hide = message.loading('文件上传中', 0)
  const formData = new FormData()
  if (Array.isArray(file)) {
    file.forEach((item) => {
      formData.append('file', item)
    })
  } else {
    formData.append('file', file)
  }
  const res = await axiosinster.request<ResultState>({
    method: 'POST',
    url: url,
    data: formData,
    params: params,
    headers: {
      'Content-Type': 'multipart/form-data',
    },
  })
  hide()
  return res.data
}

/**
 * 把参数都塞到formdata里面
 * @param url
 * @param file
 * @param params
 * @returns
 */
const filePOSTForm = async (url: string, file: any, params?: any) => {
  const hide = message.loading('文件上传中', 0)

  const formData = new FormData()
  formData.append('file', file)

  const specialFileType = ['Blob', 'File']
  for (const key in params) {
    let value = params[key]
    if (
      params[key] instanceof Object &&
      !specialFileType.includes(params[key].constructor.name)
    ) {
      value = JSON.stringify(params[key])
    }
    formData.append(key, value)
  }
  const res = await axiosinster.request<ResultState>({
    method: 'POST',
    url: url,
    data: formData,
    // params: params,
    headers: {
      'Content-Type': 'multipart/form-data',
    },
  })
  hide()
  return res.data
}

const filesPOST = async (url: string, filelist: any[], params?: any) => {
  const hide = message.loading('文件上传中', 0)
  const formData = new FormData()
  for (const f of filelist) {
    formData.append('file', f)
  }
  const res = await axiosinster.request<ResultState>({
    method: 'POST',
    url: url,
    data: formData,
    params: params,
    headers: {
      'Content-Type': 'multipart/form-data',
    },
  })
  hide()
  return res.data
}

function downFilePost(
  url: string,
  params?: any,
  contentType?: string,
  json?: boolean,
  isdownload?: boolean,
) {
  message.loading(isdownload ? '文件下载中' : '文件导出中', 0)
  axiosinster
    .request({
      method: 'POST',
      url: url,
      data: json ? params : JSON.stringify(params),
      headers: {
        'content-type': contentType ? contentType : 'application/json',
      },
      responseType: 'blob', // 服务器返回的数据类型
    })
    .then(async (response: AxiosResponse) => {
      // 判断data是blob的情况，是不是json
      const hide = message.loading(isdownload ? '文件下载中' : '文件导出中', 0)
      console.log(response.data)
      if (response.data?.type === 'application/json') {
        const text = await response.data.text()

        try {
          const parsed = JSON.parse(text) as { code?: unknown; msg?: string }
          if (parsed && typeof parsed === 'object' && 'code' in parsed) {
            hide()
            if (String(parsed.code) !== '0') {
              message.error(parsed.msg || '操作失败')
              return parsed
            }
            message.success('导出成功！')
            return parsed
          }
        } catch (e) {
          if (e && typeof e === 'object' && 'code' in e) {
            throw e
          }
        }
      }
      const disposition = decodeURIComponent(
        response.headers['content-disposition'],
      )
      const fileName =
        /filename=(?:["']?)([^"]+)(?:["']?)$/.exec(disposition)?.[1] ??
        'unnamed' // 下载文件名
      const name = fileName

      // return
      // 返回的内容
      const content = response.data
      download(content, name)
      if (isdownload) {
        message.success('下载成功！')
      } else {
        message.success('导出成功！')
      }
      return response.data
    })
    .catch((e) => {
      if (isdownload) {
        message.error('下载失败')
      } else {
        message.error('操作失败')
      }
      return { data: {} }
    })
}
// 处理下载流
function download(content: any, fileName: string) {
  // 创建一个类文件对象：Blob对象表示一个不可变的、原始数据的类文件对象
  const blob = new Blob([content])
  // URL.createObjectURL(object)表示生成一个File对象或Blob对象
  const url = window.URL.createObjectURL(blob)
  // 设置一个隐藏的a标签，href为输出流，设置download
  const dom = document.createElement('a')
  dom.style.display = 'none'
  dom.href = url
  // 指示浏览器下载url,而不是导航到它；因此将提示用户将其保存为本地文件
  dom.setAttribute('download', fileName)
  document.body.appendChild(dom)
  dom.click()
}

// eslint-disable-next-line
export default {
  GET: get,
  POST: post,
  DELETE: del,
  downFileGET: fileGET,
  uploadFilePOST: filePOST,
  downFilePost: downFilePost,
  filesPOST,
  filePOSTForm,
}
import { HTTP_STATUS } from './httpstatu'
import logerror from './logerror'
import Axios, { AxiosResponse, Canceler } from 'axios'
import qs from 'query-string'
import { GetLocalStorage, DelLocalStorage, getUserId } from './util'
import { message } from 'antd'
import { CustomerWarning } from '../components/ModalUser'
import { history } from '../redux/store'
import InterceptRequestApi from '../api/InterceptRequestApi'
import { socketdisconnect } from './sockClient'
import { ResultState } from './public'
// 正在进行中的请求列表
const reqListData: any = []
// 请求到的数据
let resListData: { data: any; url?: string }[] = []
/**
 * 阻止重复请求
 * @param {array} reqList - 请求缓存列表
 * @param {string} url - 当前请求地址
 * @param {function} cancel - 请求中断函数
 */
const stopRepeatRequest = (
  reqList: string[],
  cancel: Canceler,
  url?: string,
) => {
  for (let i = 0; i < reqList.length; i++) {
    if (reqList[i] === url) {
      // 传递 url标识
      cancel(url)
      return
    }
  }
  reqList.push(url ? url : '')
}
/**
 * 允许某个请求可以继续进行
 * @param {array} reqList 全部请求列表
 * @param {string} url 请求地址
 */
const allowRequest = (reqList: any, url?: string) => {
  for (let i = 0; i < reqList.length; i++) {
    if (reqList[i] === url) {
      reqList.splice(i, 1)
      break
    }
  }
}

/**
 * 存储返回数据
 * @param data 响应数据
 * @param url 请求url
 */
const storageResponse = (data: any, url?: string) => {
  // 剔除旧数据
  const res = resListData.filter((item) => item.url !== url)
  // push 新数据
  res.push({
    data: data,
    url: url,
  })
  resListData = res
}

/**
 * 获取响应的数据
 * @param url
 */
const getUrlResponse = (url: string) => {
  // 旧数据
  const data = [...resListData]
  const res = data.filter((item) => item.url === url)
  if (res.length === 1) {
    return res[0].data
  }
  return { msg: '请勿重复操作' }
}

const axiosinster = Axios.create()
// 发送请求拦截
axiosinster.interceptors.request.use(
  (config) => {
    const url = config.url || ''
    const f = InterceptRequestApi.indexOf(url)
    if (f !== -1) {
      // 重复请求标识
      // eslint-disable-next-line @typescript-eslint/no-empty-function
      let cancel: Canceler = () => {}
      // 设置cancelToken对象
      config.cancelToken = new Axios.CancelToken(function (c: Canceler) {
        cancel = c
      })
      // 阻止重复请求。当上个请求未完成时，相同的请求不会进行
      stopRepeatRequest(reqListData, cancel, config.url)
    }
    // 获取本地token
    config.headers.Authorization = GetLocalStorage('SRM_TOKEN')

    // SUPPLIER_ORDER_ID 物流H5页面订单ID
    if (
      !GetLocalStorage('SRM_TOKEN') &&
      !sessionStorage.getItem('SUPPLIER_ORDER_ID')
    ) {
      history.replace('/login')
      return config
    }
    return config
  },
  (error) => {
    // 对请求错误做些什么
    return Promise.reject(error)
  },
)
//  响应拦截
axiosinster.interceptors.response.use(
  (response) => {
    // 增加延迟，相同请求不得在短时间内重复发送
    allowRequest(reqListData, response.config.url)
    // 对响应数据做点什么
    if (
      response.headers['content-type'] ===
      'application/octet-stream;charset=UTF-8'
    ) {
      return response
    }
    // 判断是否登录超时、未登录、权限不足等信息
    if (response.status === 200 && response.data.code === -1) {
      message.info('登录超时请重新登录！')
      // 销毁链接取消订阅
      socketdisconnect()
      DelLocalStorage('SRM_TOKEN')
      history.replace('/login')
    }
    if (response.status === HTTP_STATUS.NOT_FOUND) {
      logerror('api', '请求资源不存在')
    } else if (response.status === HTTP_STATUS.SERVER_ERROR) {
      logerror('api', '服务器异常')
    } else if (response.status === HTTP_STATUS.BAD_GATEWAY) {
      logerror('api', '服务端出现了问题')
    } else if (response.status === HTTP_STATUS.FORBIDDEN) {
      logerror('api', '没有权限访问')
    } else if (response.status === HTTP_STATUS.SUCCESS) {
      if (response.data.code === 3) {
        CustomerWarning({
          title: '提示',
          content: response.data.msg,
        })
        response.data.code = 0
      } else if (response.data.code === 1) {
        CustomerWarning({
          title: '提示',
          content: response.data.msg,
        })
      }
    }
    storageResponse(response.data, response.config.url)
    return response
  },
  (error) => {
    if (Axios.isCancel(error)) {
      const url = error.message
      // 拦截重复提交接口返回数据
      message.warning('请勿重复操作')
      return getUrlResponse(url)
    } else {
      // 增加延迟，相同请求不得在短时间内重复发送
      allowRequest(reqListData, error.config.url)
    }
    // 对响应错误做点什么
    logerror('api', '请求失败，网络连接异常')
    return Promise.reject(error)
  },
)

interface Params {
  data: { url: string; data?: any; contentType?: string }
  method: string
}
const options = async <T = any>(params: Params) => {
  const { url, data } = params.data
  const { method } = params
  const content_Type = 'application/json;charset=UTF-8'

  const OPTIONS = {
    ...{
      url: url,
      method: method,
      headers: {
        Accept: 'application/json;charset=UTF-8',
        'content-type': content_Type,
      },
    },
    ...data,
  }
  const res = await axiosinster.request<ResultState<T>>(OPTIONS)
  return res.data
}

const get = <T = any>(url: string, query?: any, data?: any) =>
  options<T>({
    data: {
      url: url,
      data: {
        data: data,
        params: { ...query, userId: getUserId() },
      },
    },
    method: 'GET',
  })
const post = <T = any>(
  url: string,
  data?: any,
  contentType?: string,
  query?: any,
  appendUserId = true,
) => {
  let newData
  if (contentType === 'multipart/form-data') {
    // formdata传参
    const formData = new FormData()
    const params = { userId: getUserId(), ...(data || {}) }
    const specialFileType = ['Blob', 'File']
    for (const key in params) {
      let value = params[key]
      if (
        params[key] instanceof Object &&
        !specialFileType.includes(params[key].constructor.name)
      ) {
        value = JSON.stringify(params[key])
      }
      formData.append(key, value)
    }
    newData = formData
  } else if (contentType === 'application/json') {
    let obj = {}
    try {
      obj = typeof data === 'string' ? JSON.parse(data) : data || {}
    } catch {
      obj = {}
    }
    newData = JSON.stringify(
      appendUserId ? { ...obj, userId: getUserId() } : obj,
    )
  } else {
    let obj = {}
    if (typeof data === 'string') {
      obj = qs.parse(data)
    } else {
      obj = data || {}
    }
    newData = qs.stringify({ ...obj, userId: getUserId() })
  }

  let dataToSend
  if (contentType === 'multipart/form-data') {
    dataToSend = newData
  } else if (typeof newData === 'object' && newData !== null) {
    dataToSend = newData // 已经处理过 userId
  } else {
    dataToSend = newData // 字符串类型
  }

  return options<T>({
    data: {
      url: url,
      data: { data: dataToSend, params: query },
      contentType: contentType,
    },
    method: 'POST',
  })
}
const del = (url: string, data?: any, contentType?: string, query?: any) => {
  let newData
  contentType === 'application/json'
    ? (newData = JSON.stringify(data))
    : (newData = qs.stringify(data))
  if (contentType === 'multipart/form-data') {
    // formdata传参
    const formData = new FormData()
    const params = data
    const specialFileType = ['Blob', 'File']
    for (const key in params) {
      let value = params[key]
      if (
        params[key] instanceof Object &&
        !specialFileType.includes(params[key].constructor.name)
      ) {
        value = JSON.stringify(params[key])
      }
      formData.append(key, value)
    }
    newData = formData
  }

  return options({
    data: {
      url: url,
      data: { data: newData, params: query },
      contentType: contentType,
    },
    method: 'DELETE',
  })
}

/**
 * 文件导出
 * @param url 请求路径
 * @param params 参数
 */
const fileGET = (url: string, params?: any) => {
  message.loading('文件导出中', 0)
  axiosinster
    .request({
      method: 'GET',
      url: url,
      params: params,
      headers: {
        Accept: 'application/json;charset=UTF-8',
        'content-type': 'application/x-www-form-urlencoded',
      },
      responseType: 'blob', // 服务器返回的数据类型
    })
    .then((response: AxiosResponse) => {
      const disposition = decodeURIComponent(
        response.headers['content-disposition'],
      )
      const fileName = disposition.split(';')[2].split('filename=')[1] // 下载文件名
      const name = fileName.substring(1, fileName.length - 1)
      // 返回的内容
      const content = response.data
      download(content, name)
      message.success('导出成功！')
      return response.data
    })
    .catch(() => {
      message.error('操作失败')
      return { data: {} }
    })
}
/**
 * 文件导入
 * @param url 请求路径
 * @param file 文件对象
 * @param params 参数
 */
const filePOST = async (url: string, file: any, params?: any) => {
  const hide = message.loading('文件上传中', 0)
  const formData = new FormData()
  if (Array.isArray(file)) {
    file.forEach((item) => {
      formData.append('file', item)
    })
  } else {
    formData.append('file', file)
  }
  const res = await axiosinster.request<ResultState>({
    method: 'POST',
    url: url,
    data: formData,
    params: params,
    headers: {
      'Content-Type': 'multipart/form-data',
    },
  })
  hide()
  return res.data
}

/**
 * 把参数都塞到formdata里面
 * @param url
 * @param file
 * @param params
 * @returns
 */
const filePOSTForm = async (url: string, file: any, params?: any) => {
  const hide = message.loading('文件上传中', 0)

  const formData = new FormData()
  formData.append('file', file)

  const specialFileType = ['Blob', 'File']
  for (const key in params) {
    let value = params[key]
    if (
      params[key] instanceof Object &&
      !specialFileType.includes(params[key].constructor.name)
    ) {
      value = JSON.stringify(params[key])
    }
    formData.append(key, value)
  }
  const res = await axiosinster.request<ResultState>({
    method: 'POST',
    url: url,
    data: formData,
    // params: params,
    headers: {
      'Content-Type': 'multipart/form-data',
    },
  })
  hide()
  return res.data
}

const filesPOST = async (url: string, filelist: any[], params?: any) => {
  const hide = message.loading('文件上传中', 0)
  const formData = new FormData()
  for (const f of filelist) {
    formData.append('file', f)
  }
  const res = await axiosinster.request<ResultState>({
    method: 'POST',
    url: url,
    data: formData,
    params: params,
    headers: {
      'Content-Type': 'multipart/form-data',
    },
  })
  hide()
  return res.data
}

function downFilePost(
  url: string,
  params?: any,
  contentType?: string,
  json?: boolean,
  isdownload?: boolean,
) {
  message.loading(isdownload ? '文件下载中' : '文件导出中', 0)
  axiosinster
    .request({
      method: 'POST',
      url: url,
      data: json ? params : JSON.stringify(params),
      headers: {
        'content-type': contentType ? contentType : 'application/json',
      },
      responseType: 'blob', // 服务器返回的数据类型
    })
    .then(async (response: AxiosResponse) => {
      // 判断data是blob的情况，是不是json
      const hide = message.loading(isdownload ? '文件下载中' : '文件导出中', 0)
      console.log(response.data)
      if (response.data?.type === 'application/json') {
        const text = await response.data.text()

        try {
          const parsed = JSON.parse(text) as { code?: unknown; msg?: string }
          if (parsed && typeof parsed === 'object' && 'code' in parsed) {
            hide()
            if (String(parsed.code) !== '0') {
              message.error(parsed.msg || '操作失败')
              return parsed
            }
            message.success('导出成功！')
            return parsed
          }
        } catch (e) {
          if (e && typeof e === 'object' && 'code' in e) {
            throw e
          }
        }
      }
      const disposition = decodeURIComponent(
        response.headers['content-disposition'],
      )
      const fileName =
        /filename=(?:["']?)([^"]+)(?:["']?)$/.exec(disposition)?.[1] ??
        'unnamed' // 下载文件名
      const name = fileName

      // return
      // 返回的内容
      const content = response.data
      download(content, name)
      if (isdownload) {
        message.success('下载成功！')
      } else {
        message.success('导出成功！')
      }
      return response.data
    })
    .catch((e) => {
      if (isdownload) {
        message.error('下载失败')
      } else {
        message.error('操作失败')
      }
      return { data: {} }
    })
}
// 处理下载流
function download(content: any, fileName: string) {
  // 创建一个类文件对象：Blob对象表示一个不可变的、原始数据的类文件对象
  const blob = new Blob([content])
  // URL.createObjectURL(object)表示生成一个File对象或Blob对象
  const url = window.URL.createObjectURL(blob)
  // 设置一个隐藏的a标签，href为输出流，设置download
  const dom = document.createElement('a')
  dom.style.display = 'none'
  dom.href = url
  // 指示浏览器下载url,而不是导航到它；因此将提示用户将其保存为本地文件
  dom.setAttribute('download', fileName)
  document.body.appendChild(dom)
  dom.click()
}

// eslint-disable-next-line
export default {
  GET: get,
  POST: post,
  DELETE: del,
  downFileGET: fileGET,
  uploadFilePOST: filePOST,
  downFilePost: downFilePost,
  filesPOST,
  filePOSTForm,
}
